import * as Sentry from '@sentry/react';

/**
 * Initialize Sentry error tracking. Errors-only: no performance tracing and no
 * session replay (free-plan quota is ~5k errors/mo, so we keep it lean).
 *
 * No-op when REACT_APP_SENTRY_DSN is unset — local dev without a DSN does
 * nothing. The DSN is never hardcoded; it must come from the environment.
 */
export function initSentry(): void {
  const dsn = process.env.REACT_APP_SENTRY_DSN;
  if (!dsn) return;

  Sentry.init({
    dsn,
    environment: process.env.NODE_ENV,
    tracesSampleRate: 0,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
    sendDefaultPii: false,
    ignoreErrors: [
      'ResizeObserver loop limit exceeded',
      'ResizeObserver loop completed with undelivered notifications',
      'Non-Error promise rejection captured',
    ],
  });
}
